import axios from '@/libs/request';

// 用户登录接口  手游系统->用户相关接口
export const login = data => axios.ecRequest({ url: '/user/login/username', data });
// 手机登录获取验证码接口(v2版本使用)
export const getCellLoginCode = data => axios.request({ url: '/user/sms/code/verification', data });
// 手机验证码登录接口(v2版本使用)
export const cellSmsLoginApi = data => axios.ecRequest({ url: '/user/login/phone', data });
// 手机登录验证码接口(v2版本使用)
export const cellCredentialLoginApi = data => axios.ecRequest({ url: '/user/login/credential', data });
// bt盒子登录接口
export const btLoginApi = data => axios.ecRequest({ url: '/user/login/box-code', data });
// 静默登录
export const silentLogin = data => axios.ecRequest({ url: '/user/login/silent', data });

// 获取微信登录开启状态
export const isNeedWeChatLogin = data => axios.request({ url: '/wechat/platform/auth-status', data, unHint: true });
// 获取微信账号登录凭证接口
export const getWxCredential = data => axios.request({ url: '/wechat/platform/credential', data, unHint: true });

// 用户注册接口  手游系统->用户相关接口
export const register = data => axios.ecRequest({ url: '/user/register/username', data });
// 带滑块验证的快速注册接口
export const captchaRegister = data => axios.ecRequest({ url: '/user/register/username/captcha', data });
// 根据设备ID查找用户名和密码（文档没有）
export const searchUser = data => axios.request({ url: '/user/ysdkUserUpdate', data });
// 判断是否是应用宝强制正常登录
export const ysdkStatus = appkey => axios.request({ method: 'get', url: `/game/info/status/${appkey}`, unHint: true });
// 获取一键注册账号
export const quickRegister = data => axios.ecRequest({ url: '/user/register/register-info', data });
// 获取手机注册账号验证码接口
export const getVerifyCode = data => axios.request({ url: '/user/sms/register-verify-code', data });
// 手机注册接口
export const phoneRegister = data => axios.ecRequest({ url: '/user/register/phone', data });
// 获取通用类短信验证码
export const getSmsCode = data => axios.request({ url: '/user/sms/code', data });
// 忘记密码
export const forgetPwd = data => axios.request({ url: '/user/info/password/reset', data });
// 防沉迷轮询上报接口
export const antiIndulged = data => axios.request({ url: '/user/anti-addiction/beat', data, unHint: true });
// 绑定手机
export const bindTel = data => axios.request({ url: '/user/info/phone/bind', data });
// 解绑手机
export const unbundlingTel = data => axios.request({ url: '/user/info/phone/unbind', data });
// 实名认证
export const idBind = data => axios.request({ url: '/user/anti-addiction/authentication', data });
// 修改密码
export const userChangePwd = data => axios.request({ url: '/user/info/password/change', data });
// 华为包提审使用三方登录接口
export const huaweiLogin = data => axios.request({ url: '/oauth/thirdAuthorize/3', data });
// 检查防沉迷开关接口
export const checkAntiIndulged = data => axios.request({ url: '/user/anti-addiction/check', data, unHint: true });
// 真实实名认证检查
export const idBindCheck = data => axios.request({ url: '/user/anti-addiction/authentication/check', data, unHint: true });
// 游客模式上报接口
export const guestReport = data => axios.request({ url: '/antiIndulged/guest', data, unHint: true });
// vip界面埋点上报
export const visitorsAdd = data => axios.request({ url: '/data/vip', data });
// 冻结账号强制下线轮训接口
export const userStatus = data => axios.request({ url: '/user/info/status', data, unHint: true });
// 请求公众号引导相关信息
export const getOfficialInfo = data => axios.request({ url: '/oauth/official', data, unHint: true });
// 判断是否符合vip资格
export const checkVip = data => axios.request({ url: '/user/vip/check', data, unHint: true });
// 进入防沉迷页面埋点
export const enterAntiPort = data => axios.request({ url: '/user/anti-addiction/authentication/enter', data, unHint: true });
// 公众号埋点上报 visitors/official
export const officialAccount = data => axios.request({ url: '/data/official-account', data, unHint: true });
// 手游通用埋点上报
export const eventTrack = data => axios.request({ url: '/noncore/event-track', data, unHint: true });
// 手游通用埋点上报（携带额外参数）
export const eventTrackExtra = data => axios.request({ url: '/noncore/event-track/extra', data, unHint: true });
// 手游通用埋点上报
export const flashCloseTrack = data => axios.request({ url: '/activity/flashCloseReport', data, unHint: true });
// 账号注销
export const writeOffApi = data => axios.request({ url: '/user/close', data });

// 发送验证码(修改密码，解绑手机号)
export const getSmsCodeV2 = data => axios.request({ url: '/user/sms/code/user-id', data });

// 解绑手机号验证码验证
export const unbindVerify = data => axios.request({ url: '/user/info/phone/unbind/verify', data });

// 换绑手机号
export const phoneChange = data => axios.request({ url: '/user/info/phone/change', data });

// 修改密码(绑定手机情况下)
export const cellResetPwd = data => axios.request({ url: '/user/info/password/reset/user-id', data });

// 获取登录盒子授权码接口
export const getBoxCode = data => axios.request({ url: '/user/authorize-code', data });

// 获取盒子下载链接
export const getBoxDownloadUrlApi = params => axios.request({ method: 'get', url: '/game/sdk-float/box/download-url', params, unHint: true });

// 判断转端包是否需要展示手机号绑定窗口
export const telBindShow = (data) => axios.request({ url: '/wechat/platform/tel-bind-show', data });